import React from 'react';
import { cn } from '../../../utils/cn';

const SettingsLayout = ({ 
  children,
  className,
  ...props 
}) => {
  return (
    <div
      className={cn(
        'max-w-7xl mx-auto bg-gray-50 min-h-screen',
        'flex flex-col',
        'p-4 md:p-6', // Responsive padding
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default SettingsLayout;